import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import App from './App.vue'
import router from './router'
import { useAdminStore } from '@/stores'
import './styles/global.scss'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus)

// 刷新后恢复登录态
const token = localStorage.getItem('admin_access_token')
if (token) {
  const adminStore = useAdminStore()
  adminStore.fetchMe().catch(() => {
    // Token 失效，清除状态，由路由守卫处理跳转
    adminStore.logout()
  })
}

app.mount('#app')
